



































import {Vue, Component, Watch} from 'vue-property-decorator';
import AdminTab from '@/components/admin/AdminTab.vue';
import ChildAdminDepartment from '@/components/admin/ChildAdminDepartment.vue';
import Jobduty from '@/components/admin/Jobduty.vue';
import {GetDepartmentsService} from 'supporter';
@Component({
  components: {
    AdminTab,
    ChildAdminDepartment,
    Jobduty
  }
})
export default class AdminDepartment extends Vue {
  private GetDepartmentsData: GetDepartmentsService[] = [];
  private type: string = 'position';
  private type2: string = 'position2';
  private tab: string = '';
  @Watch('$route')
  routechange(to: any) {
    if (to.path == '/admin/list') {
      this.type = 'account';
    } else if (to.path == '/admin/department') {
      this.type = 'position';
      this.type2 = 'position2';
    } else if (to.path == '/admin/department/jobduty') {
      this.type = 'position';
      this.type2 = 'journal2';
    } else if (to.path == '/admin/department/') {
      this.type = 'position';
      this.type2 = 'position2';
    }
  }
  private created() {
    this.$api.getDepartments().then(ret => {
      if (ret && ret.data) {
        this.GetDepartmentsData = ret.data;
      }
    });
  }
  private classChange(data: string) {
    this.type2 = data;
  }

  private groupSave() {
    let searchForm: any = this.$refs.tabClick;
    searchForm.tabChanged();
  }
}
